<template>
	
	<div class="">
		<div class="row" v-if="loading">
			<div class="col col-md-12">
				<spinner></spinner>
			</div>
		</div>
		<div class="row" v-if="!loading && news.length > 0">
			<div class="col col-md-3">

				<div class="main-categories w-100" v-if="subjects">
					<a class="item px-3 py-2 d-block mb-2" v-for="subject in subjects" :key="subject.id" @click="filterBySubject(subject)"  :class="{'active': isFilteredSubject(subject)}">{{subject.label | capitalize}} {{subject.type | school}}</a>
				</div>
				<button class="btn blue w-100" @click="filteredSubjects = []" v-if="subjects" :disabled="filteredSubjects.length == 0">Počisti filter</button>
	
			</div>
			
			<div class="col col-md-9">
				<div class="categories p-3 mb-3" v-for="newsItem in filteredNews" :key="newsItem.unique_id">
					<div class="row no-gutters">
						<div class="col-md-2" @click.prevent="openNews(newsItem)">
							<img :src="newsItem.hero_image_url" class="card-img cursor">
						</div>
						<div class="col-md-10">
							<div class="card-body py-0 d-flex flex-column h-100">
								<h5 class="card-title mb-0 text-bold">
									<a @click.prevent="openNews(newsItem)" href>{{newsItem.title}}</a>
								</h5>
								<p class="card-text"><small>{{newsItem.valid_from | date}}</small></p>
								<p class="card-text" v-if="newsItem.excerpt" v-html="newsItem.excerpt"></p>
								<div class="mt-auto">
									<button class="btn green" @click.prevent="openNews(newsItem)">Preberi več</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row" v-if="!loading && news.length == 0">
			<div class="col col-md-12">
				<p class="text-center">Trenutno ni novic.</p>
			</div>
		</div>
	</div>
</template>

<script>
import slugify from 'slugify'
import queryString from 'query-string'
import Spinner from './Spinner.vue';

export default {
	components: {
		Spinner
	},
	data() {
		return {
            loading: true,
            subjects: undefined,
			filteredSubjects: [],
			news: []
		};
	},
	mounted() {
		this.loadNews();
	},
	methods: {
		loadNews() {
            this.loading = true
            axios.get(this.route('warehouse.news.all')).then(({data}) => {
                this.loading = false
				this.subjects = data.subjects
				this.news = data.news

				this.setupInitalFilter()
            })
		},
		openNews(news) {
			let url = this.route('warehouse.news.single', news.unique_id)
			if (news.loginRequred) {
				location = this.route('login') + '?return-url=' + url
			} else {
				location = url
			}
		},
		setupInitalFilter() {
			if (location.hash != '') {
				let subjects = Object.keys(queryString.parse(location.hash))
				subjects.forEach(subject => {
					this.subjects.forEach(item => {
						if (slugify(`${item.label}-${item.type}`, { lower: true }) == subject) {
							this.filterBySubject(item)
						}
					})
				})
			} else {
				this.subjects.forEach(subject => {
					if (subject.ownSubject) {
						console.log('here');
						this.filterBySubject(subject);
					}
				});
			}
		},
        filterBySubject(subject) {
            if (!this.isFilteredSubject(subject)) {
                this.filteredSubjects.push(subject)
            } else {
                let index = this.filteredSubjects.indexOf(subject)
                this.filteredSubjects.splice(index, 1)
            }
        },
        isFilteredSubject(subject) {
            return this.filteredSubjects.indexOf(subject) >= 0
		},
		hasFilteredSubject(news, subject) {
			return news.subjects.reduce((acc, sub) => {
				if (sub.id == subject.id) {
					return true
				}
				return acc
			}, false)
		}
	},
    filters: {
        capitalize(text) {
            return text.charAt(0).toUpperCase() + text.slice(1)
		},
		date(value) {
            let date = new Date(Date.parse(value))
            return date.toLocaleDateString('sl-SI')
		},
		school(text) {
			if (text == 'os') {
				return '(OŠ)'
			}
			if (text == 'ss') {
				return '(SŠ)'
			}
			return text.toUpperCase()
		}
	},
	watch: {
		filteredSubjects() {
			let hash = []
			this.filteredSubjects.forEach(subject => {
				hash.push(slugify(`${subject.label}-${subject.type}`, { lower: true }))
			})
			location.hash = '#' + hash.join('&')
		}
	},
	computed: {
		filteredNews() {
			if (this.filteredSubjects.length == 0) {
				return this.news
			}

			let filteredNews = this.news.filter(item => {
				for (let sub of this.filteredSubjects) {
					if (this.hasFilteredSubject(item, sub)) {
						return true
					}
				}
				return false
			});
			return filteredNews
		}
	}
};
</script>

<style lang="scss" scoped>

	.list-group-item {
		cursor: pointer;
	}
	.btn {
		border-radius: 8px;

		&:disabled {
			pointer-events: none;
		}
	}
	h5 {
		font-weight: 600;
	}

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/News.vue